
import gql from 'graphql-tag';

export default gql`
mutation updateSellerInCart($sellerId: String!, $sellerName: String!){
  updateSellerInCart(sellerId: $sellerId, sellerName: $sellerName) { 
    sellerInfo {
      sellerId,
      sellerName,
    } 
  }
}
`;
